import React from "react";

// Components
import { Table, Spin } from "antd";
import { Link } from "react-router-dom";
import { ColumnProps } from "antd/lib/table";
import { CarrierLogo, LogoWrapper } from "./CarriersTable.styles";

// Interfaces
import { Fulfillment } from "@secondcloset/types";
type Carrier = Fulfillment.Carrier;

interface CarriersTableProps {
  loading: boolean;
  data: Carrier[];
  organizationID?: string;
}

const CarriersTable: React.FC<CarriersTableProps> = ({ loading, data, organizationID }) => {
  if (loading) return <Spin tip="Fetching carriers..." />;

  const renderLogo = (logo: Carrier["logo"]) => {
    return (
      <LogoWrapper>
        <CarrierLogo src={logo?.url} />
      </LogoWrapper>
    );
  };

  const renderServiceCodes = (serviceCodes: string[]) => {
    return serviceCodes
      ? serviceCodes.map((serviceCode: string, index: number) =>
          index === serviceCodes.length - 1 ? `${serviceCode}` : `${serviceCode}, `
        )
      : null;
  };

  const renderEdit = (_: undefined, carrier: Carrier) => (
    <Link to={`/organizations/${organizationID}/carriers/${carrier.id}/edit`}>Edit</Link>
  );

  const getColumns = (): ColumnProps<any>[] => [
    {
      title: "Logo",
      dataIndex: "logo",
      key: "logo",
      render: renderLogo,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Carrier Code",
      dataIndex: "carrier_code",
      key: "carrier_code",
    },
    {
      title: "External ID",
      dataIndex: "external_id",
      key: "external_id",
    },
    {
      title: "External Platform",
      dataIndex: "external_platform",
      key: "external_platform",
    },
    {
      title: "Service Codes",
      dataIndex: "enabled_service_codes",
      key: "enabled_service_codes",
      render: renderServiceCodes,
    },
    { title: "Edit", key: "edit", render: renderEdit },
  ];

  return (
    <Table
      dataSource={data}
      columns={getColumns()}
      size="small"
      pagination={false}
      scroll={{ x: 800 }}
      rowKey={(record) => record.id}
      loading={loading}
    />
  );
};

export default CarriersTable;
